import { defineMessage } from 'react-intl';

export const searchReplaceFallbackHeadline = defineMessage({
  id: 'rde.search-replace-products.headline-fallback',
  defaultMessage: 'Ähnliche Artikel',
});
